import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Hero() {

  const slides = [
    {
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350",
      title: "Best School ERP Software",
      desc: "Smart digital school management system for students, teachers and parents."
    },
    {
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
      title: "Manage Your School Digitally",
      desc: "Simplify attendance, fees, exams and communication."
    },
    {
      image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1",
      title: "Transform Education",
      desc: "Modern ERP system for schools and institutions."
    }
  ];

  return (
    <div className="w-full">

      <Swiper
        modules={[Autoplay, Navigation]}
        autoplay={{ delay: 4000 }}
        navigation
        loop
        className="w-full h-[500px]"
      >

        {slides.map((slide, index) => (
          <SwiperSlide key={index}>

            <div
              className="relative w-full h-[500px] bg-cover bg-center flex items-center"
              style={{ backgroundImage: `url(${slide.image})` }}
            >

              {/* overlay */}
              <div className="absolute inset-0 bg-black/40"></div>

              {/* text */}
              <div className="relative z-10 max-w-6xl mx-auto px-6 text-white">

                <h1 className="text-4xl md:text-5xl font-bold mb-4">
                  {slide.title}
                </h1>

                <p className="text-lg mb-6 max-w-xl">
                  {slide.desc}
                </p>

                <button className="bg-orange-500 px-6 py-3 rounded-lg hover:bg-orange-600 transition">
                  Get Free Demo
                </button>

              </div>

            </div>

          </SwiperSlide>
        ))}

      </Swiper>

    </div>
  );
}

export default Hero;